export const SITE_SUGGESTIONS_QUERY = `
  query ($searchString: String, $siteAddress: String) {
    siteSuggestions(searchString: $searchString, siteAddress: $siteAddress) {
      _id
      title
    }
  }
`;
